import { change } from 'redux-form';

import { handleErrorException, loading, success } from 'State/actions';
import { ON_HAND_REPORT_LISTING_FORM_NAME } from 'Common/FormEnum';
import { OnHandReportListingEnum } from 'Common/FieldEnum';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

import * as types from './types';

export const getOnHandItems = input => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ON_HAND_REPORT_ITEMS_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'OnHand/GetOnHandItems',
        input
      );
      dispatch(success(types.ON_HAND_REPORT_ITEMS, response.data.Data.Data));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching On Hand Items. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.ON_HAND_REPORT_ITEMS_LOADING_ERROR,
          defaultError
        )
      );
      dispatch({
        type: types.RESET_ON_HAND_REPORT_ITEMS_LOADING_ERROR,
      });
    } finally {
      dispatch(loading(types.ON_HAND_REPORT_ITEMS_LOADING, false));
    }
  };
};

export const clearOnHandItems = () => {
  return change(
    ON_HAND_REPORT_LISTING_FORM_NAME,
    OnHandReportListingEnum.ItemIds,
    []
  );
};

export const getAllSites = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ON_HAND_REPORT_SITES_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric('sitemaster');
      dispatch(success(types.ON_HAND_REPORT_SITES_DATA, response.data.Data));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while fetching sites. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.ON_HAND_REPORT_SITES_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.ON_HAND_REPORT_SITES_LOADING, false));
    }
  };
};

//fifo
export const getOnHandFIFOItems = input => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.FIFO_REPORT_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'OnHand/GetOnHandFIFOItems',
        input
      );
      dispatch(success(types.FIFO_REPORT_ITEMS, response.data.Data.Data));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching On Hand FIFO Items. Please try again.',
      };
      dispatch(
        handleErrorException(ex, types.FIFO_REPORT_LOADING_ERROR, defaultError)
      );
      dispatch({
        type: types.RESET_ON_HAND_REPORT_ITEMS_LOADING_ERROR,
      });
    } finally {
      dispatch(loading(types.FIFO_REPORT_LOADING, false));
    }
  };
};

export const setSelectedItemsSites = input => {
  return dispatch => {
    dispatch({
      type: types.SET_SELECTED_SITES_ITEMS_FOR_FIFO,
      payload: input,
    });
  };
};

//transaction details
export const getOnHandTransactionHistory = input => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.TRANSACTION_DETAILS_REPORT_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'OnHand/GetOnHandTransactionHistory',
        input
      );
      dispatch(
        success(types.TRANSACTION_DETAILS_REPORT_ITEMS, response.data.Data.Data)
      );
      dispatch({
        type: types.RESET_ON_HAND_REPORT_ITEMS_LOADING_ERROR,
      });
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching On Hand Transaction details Items. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.TRANSACTION_DETAILS_REPORT_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.TRANSACTION_DETAILS_REPORT_LOADING, false));
    }
  };
};

export const clearReportError = () => {
  return dispatch => {
    dispatch({
      type: types.CLEAR_REPORT_ERROR,
    });
  };
};

export const setSiteIds = values => {
  return change(
    ON_HAND_REPORT_LISTING_FORM_NAME,
    OnHandReportListingEnum.SiteIds,
    values
  );
};

export const setToDateMin = payload => {
  return {
    type: types.SET_TO_DATE_MIN,
    payload,
  };
};
export const setFromDateMax = payload => {
  return {
    type: types.SET_FROM_DATE_MAX,
    payload,
  };
};

export const setToDateMinForTransactionDetail = payload => {
  return {
    type: types.SET_TRAN_DETAIL_TO_DATE_MIN,
    payload,
  };
};

export const setFromDateMaxForTransactionDetail = payload => {
  return {
    type: types.SET_TRAN_DETAIL_FROM_DATE_MAX,
    payload,
  };
};



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/onhandreport/state/actions.js